import * as React from 'react';
import { IconProps } from '../types';

const IcBalance = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
       <path
      fill={props?.fill ?? '#232F3E'}
      d="M11.62 1.015c2.266-.141 4.567.434 6.481 1.644a11.065 11.065 0 0 1 4.615 5.848 11.009 11.009 0 0 1-.129 7.339 11.042 11.042 0 0 1-4.861 5.707 10.998 10.998 0 0 1-7.669 1.221 11.07 11.07 0 0 1-6.024-3.476c-1.585-1.784-2.572-4.086-2.736-6.47a11.037 11.037 0 0 1 1.973-7.14c1.879-2.724 5.05-4.51 8.35-4.673Zm0 .364c-3.406.176-6.647 2.137-8.42 5.06a10.73 10.73 0 0 0-1.492 6.73 10.61 10.61 0 0 0 2.936 6.235 10.607 10.607 0 0 0 6.212 3.136c2.29.305 4.674-.141 6.67-1.292a10.625 10.625 0 0 0 4.674-5.426c.95-2.465.95-5.284-.036-7.738a10.691 10.691 0 0 0-4.638-5.343 10.636 10.636 0 0 0-5.907-1.362Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M7.826 3.563a9.497 9.497 0 0 1 4.45-1.104v2.936A6.6 6.6 0 0 0 7.85 7.109a6.618 6.618 0 0 0-2.172 4.662 6.56 6.56 0 0 0 1.761 4.72 6.59 6.59 0 0 0 9.794-.13c1.527-1.701 2.043-4.226 1.339-6.398.927-.306 1.855-.611 2.795-.905a9.61 9.61 0 0 1-.13 6.26 9.572 9.572 0 0 1-4.05 4.885 9.514 9.514 0 0 1-5.356 1.338 9.446 9.446 0 0 1-5.214-1.867 9.58 9.58 0 0 1-3.24-4.274 9.627 9.627 0 0 1 .07-6.964 9.543 9.543 0 0 1 4.38-4.873Z"
    />
  </svg>
);

export default IcBalance;